import { Modelo } from '@ext/index';
import * as Types from './Favoritos.types';
import moment, { Moment } from 'moment';


export class IFavoritosPantalla extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Tipo: string = '';
    public Codigo: string = '';

    public getJson(): any
    {
        let json: any = {};

        json.tipo= this.Tipo;
        json.codigo= this.Codigo;

        return json;
    }

    public set(): boolean
    {

        this.Tipo = this.Json.tipo;
        this.Codigo = this.Json.codigo;

        this.Existe = true;
        return this.Existe;
    }



}


